<template>
  <div class="row" id="ff">
    <div class="col-12" v-if="!loading && result.arr">
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="card card-body">
                    <div id="chartContainer"></div>
                    <br><br><br><br>
                    <br><br><br><br>
                    <br><br><br><br>
                    <br><br><br><br>
                    <br><br><br><br>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div class="card card-body">
                    <div id="chartContainer2"></div>
                    <br><br><br><br>
                    <br><br><br><br>
                    <br><br><br><br>
                    <br><br><br><br>
                    <br><br><br><br>
                </div>
            </div>
        </div>
        <app-collapse>
            <button class="btn btn-sm btn-warning" @click="printx('s1')">
                <i class="fa fa-print"></i>
                طباعة الجدول
            </button>
            <app-collapse-item title="📈👥 نتائج الطلاب" v-show="true" id="s1">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered table-striped">
                        <thead>
                            <th>
                                م
                            </th>
                            <th>
                                الاسم
                            </th>
                            <th>
                                رقم الهوية
                            </th>
                            <th>
                                الصف
                            </th>
                            <th>
                                الفصل
                            </th>
                            <th>
                                اجمالي الدرجات
                            </th>
                            <th>
                                ترتيب الصف
                            </th>
                            <th>
                                ترتيب الفصل
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="(student, m) in result.arr" :key="student.number">
                                <td>
                                    {{ m+1 }}
                                </td>
                                <td>
                                    {{ student.name }}
                                </td>
                                <td>
                                    {{ student.number }}
                                </td>
                                <td>
                                    {{ student.classname }}
                                </td>
                                <td>
                                    {{ student.classroom }}
                                </td>
                                <td>
                                    {{ student.subjectsTotalDegrees }}
                                </td>
                                <td>
                                    {{ student.rankInGrade }}
                                </td>
                                <td>
                                    {{ student.rankInClass }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </app-collapse-item>
            <b-modal id="view-students" title="عرض الطلاب" hide-footer size="lg">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered">
                        <thead>
                            <th>
                                م
                            </th>
                            <th>
                                الطالب
                            </th>
                            <th>
                                رقم الهوية
                            </th>
                            <th>
                                الصف
                            </th>
                            <th>
                                الفصل
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="(student, m) in viewstudents" :key="m+1+student.number">
                                <td>
                                    {{ m+1 }}
                                </td>
                                <td>
                                    {{ student.name }}
                                </td>
                                <td>
                                    {{ student.number }}
                                </td>
                                <td>
                                    {{ student.classname }}
                                </td>
                                <td>
                                    {{ student.classroom }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>
            <br>
            <button class="btn btn-sm btn-warning" @click="printx('s2')">
                <i class="fa fa-print"></i>
                طباعة الجدول
            </button>
            <app-collapse-item title="📚 احصائيات المواد" v-show="true" id="s2">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered table-striped">
                        <thead>
                            <th>
                                ترتيب المادة
                            </th>
                            <th>
                                المادة
                            </th>
                            <th>
                                عدد الناجحين
                            </th>
                            <th>
                                عدد المتفوقين
                            </th>
                            <th>
                                عدد الضعفاء
                            </th>
                            <th>
                                عدد المقبولين
                            </th>
                            <th>
                                عدد الراسبين
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="(subject, m) in result.subjects" :key="subject.number">
                                <td>
                                    {{ m+1 }}
                                </td>
                                <td>
                                    {{ subject.name }}
                                </td>
                                <td>
                                    <a href="javascript:;" @click="viewstudents=subject.success" v-b-modal.view-students>
                                        {{ subject.success.length }}
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:;" @click="viewstudents=subject.good" v-b-modal.view-students>
                                        {{ subject.good.length }}
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:;" @click="viewstudents=subject.bad" v-b-modal.view-students>
                                        {{ subject.bad.length }}
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:;" @click="viewstudents=subject.accepted" v-b-modal.view-students>
                                        {{ subject.accepted.length }}
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:;" @click="viewstudents=subject.fail" v-b-modal.view-students>
                                        {{ subject.fail.length }}
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </app-collapse-item>
            <br>
            <b-modal id="view-subjects" title="عرض المواد" hide-footer size="lg">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered">
                        <thead>
                            <th>
                                م
                            </th>
                            <th>
                                المادة
                            </th>
                            <th>
                                الدرجة
                            </th>
                            <th>
                                التقدير
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="(student, m) in viewstubjects" :key="m+1+student.number">
                                <td>
                                    {{ m+1 }}
                                </td>
                                <td>
                                    {{ student.name }}
                                </td>
                                <td>
                                    {{ student.degree }}
                                </td>
                                <td>
                                    {{ student.grade }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>
            <b-modal id="sendz" title="ارسال لأولياء الأمور" hide-footer size="lg">
                <div class="row">
                    <div class="col-12 col-lg-6 g">
                        <div class="form-group">
                          <h5 for="">الرسالة</h5>
                          <textarea class="form-control" placeholder="اكتب هنا..." v-model="message" rows="3"></textarea>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 g">
                        <div class="form-group">
                          <h5 for="">المتغيرات في الرسالة</h5>
                          <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <td>
                                        {name}
                                    </td>
                                    <td>
                                        اسم الطالب
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {subjects}
                                    </td>
                                    <td>
                                        المواد
                                    </td>
                                </tr>
                            </tbody>
                          </table>
                        </div>
                    </div>
                </div>
                <div class="col-12 text-center g">
                    <div class="row">
            <div class="col-12 col-lg-6 g">
                <b-dropdown style="width: 100%"
                    id="dropdown-1" dropup size="lg"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                >
                    <template #button-content>
                        <i class="fa fa-whatsapp"></i>
                        واتساب
                    </template>
                    <b-dropdown-item @click="send('whatsapp')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-1.png')" style="width: 28px;">
                        واتساب تلقائي (الواتس الذكي)</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="send('wa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-2.png')" style="width: 28px;">
                            اداة المتصفح المجانية</span>
                    </b-dropdown-item>
                    <b-dropdown-item  @click="send('xwa')" style="border-bottom: solid 1px #ddd">
                        <span style="font-size: 18"><img :src="require('@/assets/images/whats-3.png')" style="width: 28px;">
                        الاداة المتطورة (الواتس المباشر) <i class="btn btn-danger" style="padding: 2px">جديد</i></span>
                    </b-dropdown-item>
                    <div class="text-center g">
                        <a href="/whats-methods" target="_blank">ما الفرق بينهم؟</a>
                    </div>
                </b-dropdown>
            </div>
            <div class="col-12 col-lg-6 g">
                <button class="btn btn-primary btn-block btn-lg"  @click="send('sms')">
                    <i class="fa fa-mobile"></i>
                    SMS
                </button>
                <button class="btn btn-outline-primary mt-50 btn-block btn-lg"  @click="send('push')">
                    <i class="fa fa-bell"></i>
                    إشعار الجوال
                </button>
            </div>
        </div>
                </div>
                <div class="col-12 table-responsive">
                    <table class="table table-sm table-bordered table-hover">
                        <thead>
                            <th>
                                م
                            </th>
                            <th>
                                الطالب
                            </th>
                            <th>
                                رقم الجوال
                            </th>
                            <th>
                                الرسالة
                            </th>
                        </thead>
                        <tbody v-if="result.weaks">
                            <tr v-for="(student, m) in result.weaks" :key="student.number+m*33">
                                <td>
                                    {{ m+1 }}
                                </td>
                                <td>
                                    {{ student.name }}
                                </td>
                                <td>
                                    {{ getPhone(student.number).join(',') }}
                                </td>
                                <textarea class="form-control form-control-sm bg-white" readonly rows="2">{{getMessage(student)}}</textarea>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-modal>
            <button class="btn btn-sm btn-warning" style="border-radius: 0px" @click="printx('s3')">
                <i class="fa fa-print"></i>
                طباعة الجدول
            </button>
            <button class="btn btn-sm btn-primary" style="border-radius: 0px" v-b-modal.sendz>
                <i class="fa fa-paper-plane"></i>
                ارسال لأولياء الأمور
            </button>
            <button class="btn btn-sm btn-warning" style="border-radius: 0px" @click="print()">
                <i class="fa fa-print"></i>
                طباعة إشعارات بتدني المستوى
            </button>
            <button class="btn btn-sm btn-info hideprint" style="border-radius: 0px" v-b-modal.print2>
                <i class="fa fa-print"></i>
                طباعة إشعارات بتدني المستوى للمعليمن
            </button>
            <button class="btn btn-sm btn-secondary hideprint" style="border-radius: 0px" @click="print3()">
                <i class="fa fa-print"></i>
                طباعة كشف المتابعة
            </button>

            <b-modal id="print2" title="اختيار المعلمين" hide-footer size="lg">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered">
                        <thead>
                            <th>
                                المادة
                            </th>
                            <th>
                                المعلم
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="subject in result.subjects" :key="subject.name">
                                <td>
                                    {{ subject.name }}
                                </td>
                                <td style="padding: 0px">
                                    <input type="text" style="border-radius: 0px; border: none" v-model="subjects_teachers[subject.name]" class="form-control" placeholder="اكتب هنا...">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 text-center">
                    <button class="btn btn-primary btn-lg" @click="print2()">
                        <i class="fa fa-print"></i>
                        طباعة الآن
                    </button>
                </div>
            </b-modal>
            <app-collapse-item title="👎 الطلاب الضعفاء" v-show="true" id="s3">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-sm table-bordered table-striped">
                        <thead>
                            <th>
                                م
                            </th>
                            <th>
                                الطالب
                            </th>
                            <th>
                                رقم الهوية
                            </th>
                            <th>
                                الصف
                            </th>
                            <th>
                                الفصل
                            </th>
                            <th>
                                المواد الضعيف فيها
                            </th>
                        </thead>
                        <tbody v-if="result.weaks">
                            <tr v-for="(student, m) in result.weaks" :key="student.number+m*33">
                                <td>
                                    {{ m+1 }}
                                </td>
                                <td>
                                    {{ student.name }}
                                </td>
                                <td>
                                    {{ student.number }}
                                </td>
                                <td>
                                    {{ student.classname }}
                                </td>
                                <td>
                                    {{ student.classroom }}
                                </td>
                                <td>
                                    <a href="javascript:;" @click="viewstubjects=student.subjects" v-b-modal.view-subjects>
                                        {{ student.subjects.length }}
                                        <i class="fa fa-eye"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </app-collapse-item>
        </app-collapse>
    </div>
  </div>
</template>

<script>
import CanvasJS from '@canvasjs/charts';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { BFormCheckbox, VBModal, BModal, } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        AppCollapse,
        AppCollapseItem,
        BModal
    },
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            result: {},
            viewstudents: [],
            viewstubjects: [],
            user: JSON.parse(localStorage.getItem('user')),
            file: null,
            subjects_teachers: {},
            loading: true,
            semster: semster,
            process_id: window.location.href.split("-single/")[1].split("#")[0],
            message: `ابنكم {name}
ضعيف في المواد التالية
{subjects}`,
            students: []
        }
    },
    created(){
        if(!checkPer("results")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.process()
         $.post(api + '/user/students/list', {
            jwt: this.user.jwt,
            q: "",
            page: 1,
            perpage: 10000
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response)
            }else{
                g.students = r.response
            }
        }).fail(function(){
            g.loading = false;
        })
    },
    methods: {
    pp(){window.print()},
    print2(){
        var g = this;
        var html = "";
        var win = window.open("");
        var arr = g.result.weaks;
        g.result.subjects.forEach(function(s){
            if(s.fail.length || s.bad.length || s.accepted.length){
                var students = "";
                arr.forEach(function(a){
                    a.subjects.forEach(function(b){
                        if(b.name == s.name){
                            students = students + `
                            <tr>
                                <td>${a.name}</td>
                                <td>${b.grade}</td>
                                <td>${b.degree}</td>
                            </tr>
                            `
                        }
                    })
                })
        html = html + (`
            <div class='container-fluid'>
            <div class="row" style='padding-top: 10px'>
                <div class="col-4 text-center">
                <p>
                    المملكة العربية السعودية
                    <br>
                    ${window.ministry_name}
                </p>
                </div>
                <div class="col-4 text-center">
                <img style="width: 150px !important;" src="${window.ministry_logo}">
                </div>
                <div class="col-4 text-center">
                <p style='padding-top: 5px'>
                خطاب
                <br>
                تاريخ الطباعة: ${new Date().toISOString().split("T")[0]}
                </p>
                </div>
                <div class='col-12 text-center'>
                <h5>إشعار بتدني مستوى</h5>
                </div>
                <div class='col-12'>
                    <p>
                        <strong>
                        <br>
                            المكرم المعلم ${g.subjects_teachers[s.name] ?? '----'} &nbsp;&nbsp; المحترم
                            <br>
                            السلام عليكم ورحمة الله وبركاته, وبعد:
                            <br>
                        </strong>
                        <br>
                        نرفق لكم نتيجة طلاب مادتكم (${s.name})، نأمل الإفادة عن أسباب هذه النتيجة، وما مقترحاتكم لتحسين المستوى في هذه المادة.
                        <br>
                        <br>
                        <table class='table table-bordered table-sm'>
                            <thead>
                                <th>الطالب</th>
                                <th>التقدير</th>
                                <th>الدرجة</th>
                            </thead>
                            <tbody>${students}</tbody>
                        </table>
                    </p>
                    <p>
                        <span>
                            نفيدكم بإن أسباب تدني المستوى في المادة:
                            <br>
                            (1)<span class='text-muted'>...........................................................................</span>    
                                <br>
                            (2)<span class='text-muted'>...........................................................................</span>    <br>
                            (3)<span class='text-muted'>...........................................................................</span>    
                            <br>
                            الإجراءات المقدمة من المعلم لتحسين المستوى:
                            <br>
                            (1)<span class='text-muted'>...........................................................................</span>    
                                <br>
                            (2)<span class='text-muted'>...........................................................................</span>    <br>
                            (3)<span class='text-muted'>...........................................................................</span>    
                            <br>
                            إسم المعلم: <span class='text-muted'>...............................................</span>    
                            &nbsp;
                            التوقيع: <span class='text-muted'>.................................</span>  
                            &nbsp;
                            التاريخ: <span class='text-muted'>.................................</span> 
                            <br><br>
                            إجراءات الموجه الطلابي: 
                            <br>
                            (1)<span class='text-muted'>...........................................................................</span>    
                                <br>
                            (2)<span class='text-muted'>...........................................................................</span>    
                            <br>
                             <br>
                           الموجه: <span class='text-muted'>...............................................</span>    
                            &nbsp;
                            التوقيع: <span class='text-muted'>.................................</span>  
                            &nbsp;
                            التاريخ: <span class='text-muted'>.................................</span> 
                            <br>
                            <div style='text-align: left; padding-left: 200px; padding-top: 10px'>
                            المدير
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            التوقيع
                            </div>
                        </span>
                    </p>
                </div>
            </div>
            </div>
        `)
            }
        })
        win.document.write(`
        <html dir="rtl">
            <head>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css">

                    <link rel="preconnect" href="https://fonts.googleapis.com">
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                    <link href="https://fonts.googleapis.com/css2?family=Alexandria&display=swap" rel="stylesheet">
            <style>
                .bg-dark{
                background: #DDDDDD !important
                }
                        *{
                            font-family: 'Alexandria', sans-serif;
                        }
                        .container-fluid{
                        page-break-after:always;
                        overflow: hidden;
                        }
                        .text-muted{
                            color: #ddd !important
                        }
            </style>
            </head>
            <body>
            ${html}
            </body>
        </html>
        `)
        win.document.close()
        setTimeout(() => {
            win.print()
        }, 1000);
        },
    print3(){
        var g = this;
        var html = "";
        var win = window.open("");
        var arr = g.result.weaks;
        var ddx = [];
        arr.map(function(x){
            if(ddx.includes(x.classname)){
                return false;
            }
            ddx.push(x.classname)
            return x.classname;
        }).filter(function(x){return x;}).forEach(function(classname){
            if(true){
                var students = "";
                var head = "<th>م</th><th>الطالب</th>", subjects = [];
                arr.forEach(function(a){
                    if(a.classname == classname){
                        a.subjects.forEach(function(b){
                            if(!subjects.includes(b.name)){
                                subjects.push(b.name)
                                head = head + `
                                <th>${b.name}</th>
                                `
                            }
                        })
                    }
                })
                var l =0;
                arr.forEach(function(a){
                    if(a.classname == classname){
                         l = l + 1;
                        students = students + `
                        <tr>
                            <td>${l}</td>
                            <td>${a.name}</td>
                        `
                        subjects.forEach(function(b){
                            var t = "";
                            a.subjects.forEach(function(c){
                                if(c.name == b){
                                    t = c.grade
                                }
                            })
                            students = students + `<td>${t}</td>`;
                        })
                        students = students + `
                        </tr>
                        `
                    }
                })
        html = html + (`
            <div class='container-fluid'>
            <div class="row" style='padding-top: 10px'>
                <div class="col-4 text-center">
                <p>
                    المملكة العربية السعودية
                    <br>
                    ${window.ministry_name}
                </p>
                </div>
                <div class="col-4 text-center">
                <img style="width: 150px !important;" src="${window.ministry_logo}">
                </div>
                <div class="col-4 text-center">
                <p style='padding-top: 5px'>
                <br>
                تاريخ الطباعة: ${new Date().toISOString().split("T")[0]}
                </p>
                </div>
                <div class='col-12 text-center'>
                <h5>متابعة الطلاب الحاصلين على تقدير ضعيف ومقبول في الصف ${classname}<br>بعد نتائج الفصل الدراسي ${g.semster} للعام الدراسي ${hyear_single}</h5>
               <br></div>
                <div class='col-12'>
                    <table class='table table-sm table-bordered'>
                    <thead>${head}</thead>
                        <tbody>
                            ${students}
                        </tbody>
                    </table>
                </div>
                <div class='col-12'>
            
<table class='table table-sm table-bordered'>
  <thead>
    <tr>
      <th>م</th>
      <th>الإجراء المتخذ</th>
      <th>اليوم والتاريخ</th>
      <th>ملحوظات</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>حصر الطلاب الضعاف والمتأخرين دراسياً</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>2</td>
      <td>خطاب أو إشعار لولي الأمر بالضعف والتذكير بالدرس والمتابعة</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>3</td>
      <td>استدعاء لولي الأمر إذا كان لدى الطالب ضعف في مادتين أو أكثر</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>4</td>
      <td>خطاب للمعلم بمتابعة الطلاب الضعاف في مادته</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>5</td>
      <td>تزويد المعلم الموجه بأهم الإجراءات المتخذة لرفع مستوى الطلاب الضعاف</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>6</td>
      <td>عمل لقاء جماعي لجميع الطلاب في الطابور الصباحي لرفع دافعية مستوى التحصيل الدراسي لدى الطلاب</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>7</td>
      <td>عمل لقاء جمعي للطلاب الضعاف</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>8</td>
      <td>رعاية الطلاب الموهوبين والمتأخرين والضعاف فردياً</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>9</td>
      <td>المتابعة والملاحظة المستمرة لمستوى الطالب</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>10</td>
      <td>تحويل الطالب الذي لديه صعوبات تعلم لمعلم صعوبات التعلم في المدرسة</td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>11</td>
      <td>تدوين كل ما يستجد للطالب في سجل المتابعة</td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>
            </div>
            </div>
            </div>
        `)
            }
        })
        win.document.write(`
        <html dir="rtl">
            <head>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css">

                    <link rel="preconnect" href="https://fonts.googleapis.com">
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                    <link href="https://fonts.googleapis.com/css2?family=Alexandria&display=swap" rel="stylesheet">
            <style>
                .bg-dark{
                background: #DDDDDD !important
                }
                        *{
                            font-family: 'Alexandria', sans-serif;
                        }
                        .container-fluid{
                        page-break-after:always;
                        overflow: hidden;
                        }
                        .text-muted{
                            color: #ddd !important
                        }
            </style>
            </head>
            <body>
            ${html}
            
            </body>
        </html>
        `)
        win.document.close()
        setTimeout(() => {
            win.print()
        }, 1000);
        },
        printx(f){
            var win = window.open()
            win.document.write(`
            <html dir='rtl'>
                <head>
                    <title>التحضير الذكي</title>
                    <style>
                    table, td, th {
                        border: 1px solid;
                        padding: 0px
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                    </style>
                </head>
                <body>
                    ${$("#" + f).html()}
                </body>
            </html>
            `)
            win.document.close()
            win.print()
        },
    print(){
        var g = this;
        var html = "";
        var win = window.open("");
        var arr = g.result.weaks;
        arr.forEach(function(a){
        var subjects = "";
        a.subjects.forEach(function(s){
            subjects = subjects + `
            <tr>
                <td>${s.name}</td>
                <td>${s.grade}</td>
                <td>${s.degree}</td>
            </tr>
            `
        })
        html = html + (`
            <div class='container-fluid'>
            <div class="row" style='padding-top: 10px'>
                <div class="col-4 text-center">
                <p>
                    المملكة العربية السعودية
                    <br>
                    ${window.ministry_name}
                    <br>
                    ${g.user.name}
                </p>
                </div>
                <div class="col-4 text-center">
                <img style="width: 150px !important;" src="${window.ministry_logo}">
                </div>
                <div class="col-4 text-center">
                <p style='padding-top: 5px'>
                خطاب
                <br>
                تاريخ الطباعة: ${new Date().toISOString().split("T")[0]}
                </p>
                </div>
                <div class='col-12 text-center'>
                <h5>إشعار بتدني مستوى</h5>
                </div>
                <div class='col-12'>
                    <p>
                        <strong>
                        <br>
                            المكرم ولي أمر الطالب ${a.name} &nbsp;&nbsp; المحترم
                            <br>
                            السلام عليكم ورحمة الله وبركاته, وبعد:
                            <br>
                        </strong>
                        <br>
                        انطلاقاً من حرص إدارة المدرسة ممثلة بالتوجيه الطلابي على الإرتقاء بالمستوى التحصيلي للطالب في جميع المواد، وتنمية مستوياته التحصيلية لتحقيق أفضل النتائج عليه نطلعكم على خطة تحسين مستوى ابنكم. نأمل التعاون مع إدارة المدرسة والتوجيه الطلابي لتحقيق مستوى أفضل.
                        <br>
                        <br>
                        <table class='table table-bordered table-sm'>
                            <thead>
                                <th>المادة</th>
                                <th>التقدير</th>
                                <th>الدرجة</th>
                            </thead>
                            <tbody>${subjects}</tbody>
                        </table>
                    </p>
                    <p>
                        <span>
                            أسباب تدني المستوى من وجهة نظر الطالب:
                            <br>
                            (1)<span class='text-muted'>...........................................................................</span>    
                                <br>
                            (2)<span class='text-muted'>...........................................................................</span>    
                            <br>
                            إسم الطالب: <span class='text-muted'>...............................................</span>    
                            &nbsp;
                            التوقيع: <span class='text-muted'>.................................</span>  
                            &nbsp;
                            التاريخ: <span class='text-muted'>.................................</span> 
                            <br><br>
                            رأي ولي الأمر: 
                            <br>
                            (1)<span class='text-muted'>...........................................................................</span>    
                                <br>
                            (2)<span class='text-muted'>...........................................................................</span>    
                            <br>
                           إسم ولي الأمر: <span class='text-muted'>...............................................</span>    
                            &nbsp;
                            التوقيع: <span class='text-muted'>.................................</span>  
                            &nbsp;
                            التاريخ: <span class='text-muted'>.................................</span> 
                            <br>
                             <br>
                           الموجه: <span class='text-muted'>...............................................</span>    
                            &nbsp;
                            التوقيع: <span class='text-muted'>.................................</span>  
                            &nbsp;
                            التاريخ: <span class='text-muted'>.................................</span> 
                            <br>
                            <div style='text-align: left; padding-left: 200px; padding-top: 10px'>
                            المدير
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            التوقيع
                            </div>
                        </span>
                    </p>
                </div>
            </div>
            </div>
        `)
            
        })
        win.document.write(`
        <html dir="rtl">
            <head>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css">

                    <link rel="preconnect" href="https://fonts.googleapis.com">
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                    <link href="https://fonts.googleapis.com/css2?family=Alexandria&display=swap" rel="stylesheet">
            <style>
                .bg-dark{
                background: #DDDDDD !important
                }
                        *{
                            font-family: 'Alexandria', sans-serif;
                        }
                        .container-fluid{
                        page-break-after:always;
                        max-height: 100vh;
                        overflow: hidden;
                        }
                        .text-muted{
                            color: #ddd !important
                        }
            </style>
            </head>
            <body>
            ${html}
            </body>
        </html>
        `)
        win.document.close()
        setTimeout(() => {
            win.print()
        }, 1000);
        },
        getMessage(student){
            var g = this;
            return g.message
            .replace("{name}", student.name)
            .replace("{subjects}", student.subjects.map(function(x){return x.name + ' ('+x.grade+')'}).join("\n"))
        },
        send(method){
            var g = this;
            var arr = g.result.weaks.map(function(x){
                x.phones = g.getPhone(x.number)
                return x;
            });
            if(!confirm(`متأكد من ارسال ${arr.length} رسالة؟`)){return false;}
            var messages = [];
            arr.forEach(function(a){
                messages.push({
                    phones: a.phones,
                    message: g.getMessage(a)
                })
            })
            if(method == 'wa'){
                $("#sendmodalwaarray").val(JSON.stringify(messages))
                $("#sendmodalwatype").val("results")
                $("#sendWAModal").click()
            }else{
                $.post(api + '/user/messages/send-arr', {
                    jwt: g.user.jwt,
                    arr: JSON.stringify(messages),
                    method: method,
                    type: "results"
                }).then(function(r){
                    g.loaded = true;
                    if(r.status != 100){
                        alert(r.response, 200)
                    }else{
                        alert("تم الارسال بنجاح٫ يمكنك تصفح ارشيف الرسائل", 100)
                    }
                }).fail(function(){
                    alert("حدث خطأ", 200)
                })
            }
        },
        getPhone(i){
            var g = this;
            var p = [];
            g.students.forEach(function(a){
                if(a.number == i){
                    p = a?.phones
                }
            })
            return p;
        },
        listenFile() {
            var g = this;
            g.process_id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                return v.toString(16);
            });
            g.loading = true;
            var Upload = function (file) {
                this.file = file;
            };
            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload-tmp-files',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    $("#progress-wrp").fadeOut("slow");
                    if(data.status != 100){
                       return alert(data.response, 200)
                    }
                    g.file = data.response
                    g.step = 4;
                    g.process()
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };

            Upload.prototype.progressHandling = function (event) {
                var percent = 0;
                var position = event.loaded || event.position;
                var total = event.total;
                var progress_bar_id = "#progress-wrp";
                if (event.lengthComputable) {
                percent = Math.ceil((position / total) * 100);
                }
                // update progressbars classes so it fits your code
                $(progress_bar_id + " .progress-bar").css("width", +percent + "%");
                $(progress_bar_id + " .status").text(percent + "%");
            };
            $("#progress-wrp").fadeIn("slow");
            var file = $("#ingredient_file")[0].files[0];
            var upload = new Upload(file);

            // maby check size or type here with upload.getSize() and upload.getType()

            // execute upload
            upload.doUpload();
        },
        process(){
            var g = this;
            $.post(api + '/user/results/fast-single', {
                jwt: this.user.jwt,
                process_id: g.process_id
            })
            .then(function(r){
                g.loading = false;
                if(r.status == 100){
                    g.result = r.response;
                    function compare( a, b ) {
                        if ( a.subjectsTotalDegrees < b.subjectsTotalDegrees ){
                            return 1;
                        }
                        if ( a.subjectsTotalDegrees > b.subjectsTotalDegrees ){
                            return -1;
                        }
                        return 0;
                    }
                    function compare2( a, b ) {
                        if ( a.rank < b.rank ){
                            return 1;
                        }
                        if ( a.rank > b.rank ){
                            return -1;
                        }
                        return 0;
                    }
                    g.result.arr = g.result.arr.map(function(x){
                        if(!x.subjectsTotalDegrees == "" || !x.subjectsTotalDegrees){
                            x.subjectsTotalDegrees = 0;
                            x.subjects.forEach(function(a){
                                x.subjectsTotalDegrees = x.subjectsTotalDegrees + new Number(a.degree ?? 0);
                            })
                        }
                        return x;
                    })
                    g.result.arr.sort( compare );
                    g.result.subjects.sort( compare2 );
                    g.result.classes.sort( compare2 );
                    g.result.weaks = [];
                    g.result.arr.forEach(function(a){
                        var add = false;
                        a.subjects.forEach(function(x){
                            if(x.grade.includes('ضعيف') || x.grade.includes('مقبول') || x.grade.includes('راسب')){
                                add = true;
                            }
                        })
                        if(add){
                            a.subjects = a.subjects.filter(function(x){
                                if(x.grade.includes('ضعيف') || x.grade.includes('مقبول') || x.grade.includes('راسب')){
                                    return x;
                                }
                                return false;
                            })
                            g.result.weaks.push(a)
                        }
                    })
                    g.result = JSON.parse(JSON.stringify(g.result))
                    setTimeout(() => {
                        var chart = new CanvasJS.Chart("chartContainer", {
                            theme: "light1", // "light2", "dark1", "dark2"
                            animationEnabled: false, // change to true		
                            title:{
                                text: "📚 أفضل المواد"
                            },
                            data: [
                            {
                                type: "column",
                                dataPoints: g.result.subjects.map(function(x){
                                    return {
                                        label: x.name,
                                        y: x.success.length
                                    }
                                })
                                // [
                                //     { label: "apple",  y: 10  },
                                //     { label: "orange", y: 15  },
                                //     { label: "banana", y: 25  },
                                //     { label: "mango",  y: 30  },
                                //     { label: "grape",  y: 28  }
                                // ]
                            }
                            ]
                        });
                        chart.render();
                        var chart = new CanvasJS.Chart("chartContainer2", {
                            theme: "light1", // "light2", "dark1", "dark2"
                            animationEnabled: false, // change to true		
                            title:{
                                text: "📈 أفضل الصفوف"
                            },
                            data: [
                            {
                                type: "pie",
                                dataPoints: g.result.classes.map(function(x){
                                    return {
                                        label: x.name,
                                        y: x.success.length
                                    }
                                })
                                // [
                                //     { label: "apple",  y: 10  },
                                //     { label: "orange", y: 15  },
                                //     { label: "banana", y: 25  },
                                //     { label: "mango",  y: 30  },
                                //     { label: "grape",  y: 28  }
                                // ]
                            }
                            ]
                        });
                        chart.render();
                    }, 50)
                    setTimeout(() => {
                        $('#s1 [aria-controls]').click()
                        setTimeout(() => {
                            $('#s2 [aria-controls]').click()
                        }, 50);
                        setTimeout(() => {
                            $('#s3 [aria-controls]').click()
                        }, 50);
                    }, 50);
                }else{
                    alert(r.response, 200)
                }
            })
            .fail(function(){
                g.loading = false;
                alert("حدث خطأ في الاتصال", 200)
            })
        }
    }
}
</script>

<style>
#progress-wrp {
  border: 1px solid #0099cc;
  padding: 1px;
  position: relative;
  height: 30px;
  border-radius: 3px;
  margin: 10px;
  text-align: left;
  background: #fff;
  box-shadow: inset 1px 3px 6px rgba(0, 0, 0, 0.12);
  display: none;
}

#progress-wrp .progress-bar {
  height: 100%;
  border-radius: 3px;
  background-color: greenyellow;
  width: 0;
  box-shadow: inset 1px 1px 10px rgba(0, 0, 0, 0.11);
}

#progress-wrp .status {
  top: 3px;
  left: 50%;
  position: absolute;
  display: inline-block;
  color: #000000;
}
.table-responsive{
   min-height: 0px !important;
}
</style>